
import SearchAgents from '~/js/components/search-for-agents/SearchAgents';

// Variable Declaration
const travelAgent = document.getElementById('travel-agent');
const weddingsAgent = document.getElementById('weddings-agent');

// Render react component
ReactDOM.render(<SearchAgents type="travel" />, travelAgent);
ReactDOM.render(<SearchAgents type="weddings" />, weddingsAgent);
